export default "<div [innerHTML]=\"content\"></div>\n";